import React from 'react';
import { Button } from '@material-ui/core';
import useNavButtonStyles from './button.styles';

interface ButtonProps {
  buttonType?: 'submit' | 'button';
  onNext?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disableButton?: boolean;
  buttonLabel?: string;
  dataCy?: string
}

const NavButton: React.FC<ButtonProps> = ({
  buttonLabel,
  buttonType = 'submit',
  dataCy = '',
  onNext = (): void => { },
  disableButton = false,
}): JSX.Element => {

  const classes = useNavButtonStyles();
  return (
    <div className={classes.bottomToolbar}>
      <Button
        className={buttonType === 'submit' ? classes.submitBtn : classes.defaultBtn}
        type={buttonType}
        data-cy={dataCy}
        onClick={onNext}
        disabled={disableButton}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default NavButton;